var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPillarItem4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.5,
    stroke: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 29.9999,
    r: 23.2394,
    fill: "#AEC9F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 19H19C18.4696 19 17.9609 19.2107 17.5858 19.5858C17.2107 19.9609 17 20.4696 17 21V28.3475C17 39.5487 26.4775 43.265 28.375 43.8962C28.7803 44.0341 29.2197 44.0341 29.625 43.8962C31.525 43.265 41 39.5487 41 28.3475V21C41 20.4696 40.7893 19.9609 40.4142 19.5858C40.0391 19.2107 39.5304 19 39 19ZM39 28.3488C39 38.1512 30.7063 41.4263 29 41.9963C27.3088 41.4325 19 38.16 19 28.3488V21H39V28.3488ZM23.2925 31.7075C23.1049 31.5199 22.9994 31.2654 22.9994 31C22.9994 30.7346 23.1049 30.4801 23.2925 30.2925C23.4801 30.1049 23.7346 29.9994 24 29.9994C24.2654 29.9994 24.5199 30.1049 24.7075 30.2925L27 32.585L33.2925 26.2925C33.3854 26.1996 33.4957 26.1259 33.6171 26.0756C33.7385 26.0253 33.8686 25.9994 34 25.9994C34.1314 25.9994 34.2615 26.0253 34.3829 26.0756C34.5043 26.1259 34.6146 26.1996 34.7075 26.2925C34.8004 26.3854 34.8741 26.4957 34.9244 26.6171C34.9747 26.7385 35.0006 26.8686 35.0006 27C35.0006 27.1314 34.9747 27.2615 34.9244 27.3829C34.8741 27.5043 34.8004 27.6146 34.7075 27.7075L27.7075 34.7075C27.6146 34.8005 27.5043 34.8742 27.3829 34.9246C27.2615 34.9749 27.1314 35.0008 27 35.0008C26.8686 35.0008 26.7385 34.9749 26.6171 34.9246C26.4957 34.8742 26.3854 34.8005 26.2925 34.7075L23.2925 31.7075Z",
    fill: "#0D2548"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPillarItem4);
export default __webpack_public_path__ + "static/media/icon-pillar-item-4.6f8c2e213354d6fac6b0ff7874e48c64.svg";
export { ForwardRef as ReactComponent };